export default __webpack_public_path__ + "static/media/ciduBlanco.5c8f8760.png";